







import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class BackButton extends Vue{

    back(){
        this.$router.back();
    }
}
